<app-vad-profile mat-list-item class="profile"></app-vad-profile>

<mat-nav-list>
    <a mat-list-item routerLink="/private/projects" routerLinkActive="is-active">{{ 'navigation.projects' | translate }}</a>
    <a *ngIf="admin" mat-list-item routerLink="/private/users" routerLinkActive="is-active">{{ 'navigation.users' | translate }}</a>
    <a mat-list-item routerLink="/private/profil" routerLinkActive="is-active">{{ 'navigation.profile' | translate }}</a>
    <a mat-list-item (click)="onClickLogout()">{{ 'login.logout' | translate }}</a>
</mat-nav-list>